import { request } from '../utils/request'
import { stringify } from '../utils/index'

export default {
  getgoodslist: option => request('v1/goods/getgoodslist', option), // 产品列表
  deletegoods: (option) => request('v1/goods/deletegoods' + stringify(option), option), // 删除产品
  addgoods: (option) => request('v1/goods/addgoods', option), // 新增产品
  updategoods: (option) => request('v1/goods/updategoods', option), // 修改产品
  upshelfgoods: option => request('v1/goods/upshelfgoods' + stringify(option), option), // 兑换物品上架
  downshelfgoods: option => request('v1/goods/downshelfgoods' + stringify(option), option) // 兑换物品下架
}
